import { createFileRoute } from '@tanstack/react-router'

import { exportReportDocument } from '@/components/report-viewer/export'
import { CareLogReport } from '@/components/reports/care-logs/care-log-report'
import { validateCareLogReportSearch } from '@/components/reports/care-logs/care-log-report-search'
import { ReportPage } from '@/components/reports/report-page'
import { useAuth } from '@/hooks/use-auth'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/reports/care-logs',
)({
    validateSearch: validateCareLogReportSearch,
    component: CareLogReportPage,
})

function CareLogReportPage() {
    const search = Route.useSearch()
    const navigate = Route.useNavigate()
    const { hasPermission } = useAuth()
    return (
        <ReportPage title={m.care_log_report_page_title()}>
            <CareLogReport
                search={search}
                onSearchChange={(next) =>
                    void navigate({
                        search: (prev) => ({ ...prev, ...next }),
                        replace: true,
                    })
                }
                exportDocument={
                    hasPermission('reports.export')
                        ? exportReportDocument
                        : undefined
                }
            />
        </ReportPage>
    )
}
